import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Filter } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ClientAdvancedFilter } from "./ClientAdvancedFilter";

interface FilterState {
  name_ar: string;
  name_en: string;
  mobile: string;
  company: string;
  status: string;
  generalSearch: string;
  created_at_from: string;
  created_at_to: string;
}

interface ClientInlineFilterProps {
  onFilterChange: (filters: FilterState) => void;
  statusOptions: Array<{ value: string; label: string; color: string }>;
  currentFilters?: FilterState;
}

export function ClientInlineFilter({ onFilterChange, statusOptions, currentFilters }: ClientInlineFilterProps) {
  const [isOpen, setIsOpen] = useState(false);
  
  // حساب عدد الفلاتر النشطة باستثناء البحث العام
  const activeFiltersCount = currentFilters 
    ? Object.entries(currentFilters)
        .filter(([key, value]) => key !== 'generalSearch' && value !== '')
        .length
    : 0;

  const handleFilterChange = (newFilters: FilterState) => {
    onFilterChange(newFilters);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="gap-2">
          <Filter className="h-4 w-4" />
          الفلتر المتقدم
          {activeFiltersCount > 0 && (
            <Badge variant="secondary" className="h-5 px-1.5 text-xs">
              {activeFiltersCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[800px] max-w-[90vw]" align="end">
        <ClientAdvancedFilter 
          onFilterChange={handleFilterChange} 
          statusOptions={statusOptions}
        />
      </PopoverContent>
    </Popover>
  );
}